import Handlebars from 'lib/handlebars.runtime-v2.0.0';
import { accounting } from 'lib/accounting';

export default Handlebars.registerHelper('unformatMoney', function unformatMoney(string) {
  if (string && string === 'other') {
    return string;
  }
  return accounting.unformat(string);
});
